import { SmsProviderType } from '@constants/channels';
import { preparePhoneNumberForSubmit } from '@helpers/phone';

export const smsProviderPayload = values => {
    if (values?.provider === SmsProviderType.RingCentral) {
        return {
            integrationId: values.integrationId,
            smsParameters: {
                provider: values.provider,
                phoneNumber: values.phoneNumber,
            },
        };
    }

    return {
        smsParameters: {
            senderId: values?.senderId,
            provider: values?.provider,
            accountId: values?.accountId,
            apiKey: values?.apiKey,
            token: values?.token,
            phoneNumber: preparePhoneNumberForSubmit(values.phoneNumber),
            login: values?.login,
            password: values?.password,
        },
    };
};
